import { DataGrid } from "@mui/x-data-grid";
import { Box, CircularProgress, Typography } from "@mui/material";
import dayjs from "dayjs";
// import SearchIcon from "@mui/icons-material/Search";
// import VisibilityIcon from "@mui/icons-material/Visibility";
import { styled } from "@mui/material/styles";
import { useLocation } from "react-router-dom";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

const StyledGridOverlay = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  height: "100%",
  padding: theme.spacing(4),
}));

const NoRowsOverlay = () => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
        padding: 4,
      }}
    >
      <img
        src={`${process.env.REACT_APP_BASEURL}/logo/dataGridImage.svg`}
        alt="No Data"
        width="150"
      />
      <Typography variant="h6" sx={{ fontWeight: "bold", mt: 2 }}>
        No Data Available
      </Typography>
      <Typography
        variant="body2"
        sx={{ color: "#666", textAlign: "center", maxWidth: "500px", mt: 1 }}
      >
        There is no data available to display at the moment. Please check back
        later.
      </Typography>
    </Box>
  );
};
const CustomLoadingOverlay = () => (
  <StyledGridOverlay>
    <CircularProgress />
  </StyledGridOverlay>
);

const DynamicDataGrid = ({
  rows = [],
  loading = false,
  showCheckbox = false,
  showSelectedCount = true,
  onRowSelection = () => {},
  onRowSelectionModelChange,
  rowSelectionModel,
  formatters = {},
  totalRows = 0,
  paginationModel = { page: 1, pageSize: 25 },
  onPaginationModelChange,
  setShowAllData,
  handleOpen,
  buttonName,
  hideFooter = false,
  name,
}) => {
  const location = useLocation();

  // const CustomNoResultsOverlay = () => (
  //   <StyledGridOverlay>
  //     <img src="/dataGridimage.svg" alt="No Data" width="150" />
  //     <Typography variant="h6" sx={{ fontWeight: "bold", mt: 2 }}>
  //       {location.pathname === "/jobs" ? "Jobs Data" : "Candidates Data"}
  //     </Typography>
  //     <Typography
  //       variant="body2"
  //       sx={{ color: "#666", textAlign: "center", maxWidth: "500px", mt: 1 }}
  //     >
  //       The gallery currently holds a significant amount of data, which can take
  //       considerable time to load. For a faster experience:
  //     </Typography>
  //     <Box sx={{ display: "flex", gap: 2, mt: 2 }}>
  //       <Button
  //         size="small"
  //         variant="contained"
  //         color="primary"
  //         startIcon={<SearchIcon />}
  //         onClick={handleOpen}
  //       >
  //         Search For Specific {buttonName}
  //       </Button>
  //       <Button
  //         size="small"
  //         variant="contained"
  //         color="primary"
  //         startIcon={<VisibilityIcon />}
  //         onClick={() =>
  //           setShowAllData((prev) => ({
  //             ...prev,
  //             showAllData: true,
  //           }))
  //         }
  //       >
  //         Show All Data
  //       </Button>
  //     </Box>
  //   </StyledGridOverlay>
  // );

  // const getFormattedCellValue = (value, row, field) => {
  //   if (
  //     typeof value === "string" &&
  //     !isNaN(Date.parse(value)) &&
  //     value.includes("T")
  //   ) {
  //     return dayjs(value).format("DD-MMM-YYYY");
  //   }
  //   return formatters[field] ? formatters[field](value, row) : value;
  // };
  const getFormattedCellValue = (value, row, field) => {
    const dateFields = [
      "created_at",
      "date_created",
      "date_modified",
      "Date Joined",
      "Last Active",
      "Last Profile Updated",
      "Date Posted",
      "Applied On",
      "Shortlisted On",
      "Last Active On",
      "Created On",
      "Last Job Applied",
      "timestamp",
      "date",
    ];

    if (
      dateFields.includes(field) &&
      typeof value === "string" &&
      !isNaN(Date.parse(value))
    ) {
      return dayjs(value).format("DD-MMM-YYYY");
    }

    return formatters[field] ? formatters[field](value, row) : value;
  };

  let columns = [];
  if (location.pathname === "/employer") {
    columns = [
      { field: "id", headerName: "ID", width: 100 },
      { field: "Full Name", headerName: "Full Name", width: 200 },
      { field: "Email", headerName: "Email", width: 200 },
      { field: "Date Joined", headerName: "Date Joined", width: 200 },
      { field: "Status", headerName: "Status", width: 150 },
      {
        field: "Companies Associated",
        headerName: "Companies Associated",
        width: 250,
      },
    ];
  } else if (location.pathname === "/companies") {
    columns = [
      { field: "id", headerName: "ID", width: 100 },
      { field: "Company Name", headerName: "Company Name", width: 200 },
      { field: "Branch Count", headerName: "Branch Count", width: 200 },
      { field: "Status", headerName: "Status", width: 150 },
      { field: "City", headerName: "City", width: 150 },
      { field: "State", headerName: "State", width: 150 },
      { field: "Created On", headerName: "Created On", width: 200 },
      { field: "Created By", headerName: "Created By", width: 200 },
    ];
  } else if (location.pathname === "/jobs") {
    columns = [
      { field: "id", headerName: "ID", width: 100 },
      { field: "Job Title", headerName: "Job Title", width: 200 },
      { field: "Status", headerName: "Status", width: 150 },
      { field: "Date Posted", headerName: "Date Posted", width: 200 },
      { field: "Entered By", headerName: "Entered By", width: 200 },
      { field: "Branch Name", headerName: "Branch Name", width: 200 },
      { field: "Company Name", headerName: "Company Name", width: 200 },
    ];
  } else if (location.pathname === "/candidates") {
    columns = [
      { field: "id", headerName: "ID", width: 100 },
      { field: "Full Name", headerName: "Full Name", width: 200 },
      { field: "Source", headerName: "Source", width: 200 },
      { field: "Email", headerName: "Email", width: 200 },
      { field: "Address", headerName: "Address", width: 250 },
      { field: "Last Active", headerName: "Last Active", width: 200 },
      {
        field: "Last Profile Updated",
        headerName: "Last Profile Updated",
        width: 200,
      },
      { field: "Last Job Applied", headerName: "Last Job Applied", width: 200 },
    ];
  } else if (location.pathname.startsWith("/candidates-description")) {
    columns = [
      { field: "date", headerName: "Date", width: 150 },
      { field: "type", headerName: "Type", width: 200 },
      { field: "entered", headerName: "Entered By", width: 200 },
      { field: "regarding", headerName: "Regarding", width: 200 },
      { field: "notes", headerName: "Notes", width: 400 },
    ];
  } else if (location.pathname === "/added-candidates") {
    columns = [
      {
        field: "sno",
        headerName: "S.No",
        width: 80,
        sortable: false,
        disableColumnMenu: true,
      },
      {
        field: "fileName",
        headerName: "File Name",
        flex: 1,
        minWidth: 150,
        sortable: true,
        disableColumnMenu: true,
      },
      {
        field: "fileSize",
        headerName: "File Size",
        width: 120,
        sortable: false,
        disableColumnMenu: true,
        valueFormatter: (params) => {
          const size = params.value;
          return size < 1024 * 1024
            ? `${(size / 1024).toFixed(2)} KB`
            : `${(size / (1024 * 1024)).toFixed(2)} MB`;
        },
      },
      {
        field: "status",
        headerName: "File Status",
        width: 180,
        sortable: false,
        disableColumnMenu: true,
        renderCell: (params) => {
          const isSuccess = params.value?.toLowerCase() === "successful";

          return (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                // px: 1.5,
                // py: 0.5,
                // border: `1px solid ${isSuccess ? "#2E7D32" : "#E65100"}`,
                borderRadius: "16px",
                color: isSuccess ? "#2E7D32" : "#E65100",
                fontWeight: 500,
                fontSize: "0.875rem",
                textTransform: "capitalize",
              }}
            >
              {isSuccess ? (
                <CheckCircleOutlineIcon sx={{ fontSize: 18 }} />
              ) : (
                <ErrorOutlineIcon sx={{ fontSize: 18 }} />
              )}
              {params.value}
            </Box>
          );
        },
      },
      {
        field: "message",
        headerName: "Description",
        flex: 1,
        minWidth: 150,
        sortable: false,
        disableColumnMenu: true,
      },
    ];
  } else if (location.pathname === "/users") {
    columns = [
      { field: "id", headerName: "ID", width: 100 },
      { field: "Full Name", headerName: "Full Name", width: 200 },
      { field: "email", headerName: "Email", width: 200 },
      { field: "Status", headerName: "Status", width: 200 },
      { field: "Assigned Under", headerName: "Assigned Under", width: 250 },
      { field: "Role", headerName: "Role", width: 200 },
      { field: "company_count", headerName: "Company Count", width: 200 },
    ];
  } else if (location.pathname === "/logs") {
    columns = [
      { field: "id", headerName: "Log ID", width: 100 },
      { field: "User Id", headerName: "User ID", width: 100 },
      { field: "User Name", headerName: "Full Name", width: 200 },
      { field: "Portal Name", headerName: "Portal Name", width: 200 },
      { field: "API Endpoint", headerName: "API Endpoint", width: 250 },
      { field: "Request Type", headerName: "Request Type", width: 150 },
      {
        field: "Payload",
        headerName: "Request Payload",
        width: 300,
        renderCell: (params) => {
          const payload = params.value;
          if (!payload || typeof payload !== "object") return "-";

          return (
            <div
              style={{
                whiteSpace: "normal",
                wordBreak: "break-word",
                lineHeight: "1.5",
                overflowWrap: "anywhere",
              }}
            >
              {Object.entries(payload).map(([key, value]) => (
                <div key={key}>
                  <strong>{key}:</strong> {String(value)}
                </div>
              ))}
            </div>
          );
        },
      },
      {
        field: "API Description",
        headerName: "API Description",
        width: 300,
        renderCell: (params) => (
          <div
            style={{
              whiteSpace: "normal",
              wordBreak: "break-word",
              lineHeight: "1.5",
              overflowWrap: "anywhere",
            }}
          >
            {params.value}
          </div>
        ),
      },
      {
        field: "Log Status",
        headerName: "Log Status",
        width: 100,
      },
      {
        field: "Log Message",
        headerName: "Log Message",
        width: 300,
        renderCell: (params) => (
          <div
            style={{
              whiteSpace: "normal",
              wordBreak: "break-word",
              lineHeight: "1.5",
              overflowWrap: "anywhere",
            }}
          >
            {params.value}
          </div>
        ),
      },
      { field: "timestamp", headerName: "Date", width: 100 },
      { field: "GMT Time", headerName: "Time", width: 120 },
      { field: "IP Address", headerName: "IP Address", width: 120 },
      { field: "User Agent", headerName: "User Agent", width: 250 },
    ];
  } else if (location.pathname === "/backup") {
    columns = [
      { field: "File Name", headerName: "File Name", width: 400 },
      { field: "Size", headerName: "Size", width: 200 },
      { field: "Date", headerName: "Date", width: 300 },
      {
        field: "Actions",
        headerName: "Actions",
        width: 100,
        sortable: false,
        renderCell: (params) => (
          <a
            href={params.row.url}
            // target="_blank"
            // rel="noopener noreferrer"
            style={{ color: "#000001" }}
          >
            <FileDownloadOutlinedIcon />
          </a>
        ),
      },
    ];
  } else if (
    location.pathname.startsWith("/jobs-description") &&
    name === "Applicants"
  ) {
    columns = [
      { field: "id", headerName: "ID", width: 100 },
      { field: "fullname", headerName: "Full Name", width: 200 },
      { field: "entered_by", headerName: "Created By", width: 200 },
      { field: "created_at", headerName: "Date Created", width: 150 },
      { field: "current_location", headerName: "Location", width: 200 },
      { field: "date_modified", headerName: "Applied On", width: 200 },
      { field: "source", headerName: "Source", width: 200 },
      { field: "status", headerName: "Status", width: 200 },
      { field: "isVerified", headerName: "Verification Status", width: 200 },
      { field: "notes", headerName: "Last Activity", width: 200 },
    ];
  } else if (
    location.pathname.startsWith("/jobs-description") &&
    name === "Shortlisted"
  ) {
    columns = [
      { field: "fullname", headerName: "Full Name", width: 200 },
      { field: "entered_by", headerName: "Created By", width: 200 },
      { field: "date_created", headerName: "Date Created", width: 150 },
      { field: "current_location", headerName: "Location", width: 200 },
      { field: "created_at", headerName: "Shortlisted On", width: 200 },
      { field: "isVerified", headerName: "Verification Status", width: 200 },
      { field: "last_active", headerName: "Last Active On", width: 200 },
    ];
  }

  // const updatedColumns = showCheckbox
  //   ? [
  //       {
  //         field: "select",
  //         headerName: "",
  //         sortable: false,
  //         width: 50,
  //         renderCell: (params) => (
  //           <input
  //             type="checkbox"
  //             onChange={(e) => onRowSelection(params.row, e.target.checked)}
  //           />
  //         ),
  //       },
  //       ...columns,
  //     ]
  //   : columns;
  const updatedColumns = columns;

  return (
    <Box
      sx={{
        width: "100%",
        backgroundColor: "#fff",
        borderRadius: "8px",
        height: "100%",
      }}
    >
      <DataGrid
        sx={{
          "& .MuiDataGrid-root": { border: "none" },
          "& .MuiDataGrid-columnHeaders": {
            fontWeight: "bold",
            fontSize: "14px",
            color: "#333",
          },
          "& .MuiDataGrid-row--borderBottom": {
            backgroundColor: "#D9EAFB !important",
          },
          "& .MuiDataGrid-row:nth-of-type(odd)": { backgroundColor: "#fafafa" },
          "& .MuiDataGrid-row:nth-of-type(even)": {
            backgroundColor: "#ffffff",
          },
          "& .MuiDataGrid-columnHeaderTitle": {
            fontSize: "14px",
            fontWeight: "bold",
            textTransform: "capitalize",
            color: "#2c3e50",
          },
          "& .MuiDataGrid-columnHeaderCheckbox .MuiDataGrid-columnHeaderTitleContainer":
            {
              display: "none",
            },
          "& .MuiDataGrid-cell": {
            fontSize: "13px",
            color: "#333",
            alignItems: "center",
            ...(location.pathname === "/logs" && {
              display: "flex",
              padding: "8px",
            }),
          },
          "& .MuiDataGrid-row:hover": {
            backgroundColor: "#f5f5f5",
            cursor: "pointer",
          },
        }}
        rows={rows}
        loading={loading}
        columns={updatedColumns.map((col) => ({
          ...col,
          renderCell: col.renderCell
            ? col.renderCell
            : (params) =>
                getFormattedCellValue(params.value, params.row, col.field),
        }))}
        paginationModel={paginationModel}
        onPaginationModelChange={onPaginationModelChange}
        rowsPerPageOptions={[25, 50, 75, 100]}
        checkboxSelection={showCheckbox}
        // onRowClick={onRowSelection}
        disableSelectionOnClick
        pagination
        paginationMode="server"
        rowCount={totalRows}
        hideFooter={hideFooter}
        onRowSelectionModelChange={onRowSelectionModelChange}
        rowSelectionModel={rowSelectionModel}
        onRowClick={(params) => {
          if (!params.isSelected) {
            onRowSelection(params.row);
          }
        }}
        hideFooterSelectedRowCount={showSelectedCount}
        getRowHeight={location.pathname === "/logs" ? () => "auto" : undefined}
        slots={{
          loadingOverlay: CustomLoadingOverlay,
          // noRowsOverlay:
          //   location.pathname === "/jobs" || location.pathname === "/candidates"
          //     ? CustomNoResultsOverlay
          //     : NoRowsOverlay,
          noRowsOverlay: NoRowsOverlay,
        }}
      />
    </Box>
  );
};

export default DynamicDataGrid;
